var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-600.5 -611.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(601 612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,14.062a.938.938,0,0,1-.937.937H.938A.938.938,0,0,1,0,14.062V.937A.938.938,0,0,1,.938,0H14.063A.938.938,0,0,1,15,.937Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.219,17.656V12.031h1.875l.469-2.344H17.219V8.75a1.243,1.243,0,0,1,1.406-1.406h.938V5H17.688c-1.723,0-2.812,1.35-2.812,3.281V9.687H13v2.344h1.875v5.625Z",
    transform: "translate(-6.906 -2.656)",
    fill: "var(--mainColor)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9bb650cdbd654106ac02f340b4d4f8ad.svg";
export { ForwardRef as ReactComponent };